// extracted by mini-css-extract-plugin
export default {"textInput":"TextInput_textInput__L7p22"};